import React, { useCallback } from 'react'
import useReactRouter from 'use-react-router'
import Modal from 'core/elements/modal'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { routes } from 'core/utils/routes'
import { deleteResourceQuota } from './actions'
import usePluginRouter from 'core/hooks/usePluginRouter'

export default function DeleteResourceQuotaDialog({ rows: [resourceQuota], onClose }) {
  const { history } = useReactRouter()
  const { currentPluginId } = usePluginRouter()
  const routePath = currentPluginId === 'kubevirt' ? 'kubevirtConfiguration' : 'configuration'
  const { update: deleteFn, updating: deletingResourceQuota } = useUpdateAction(deleteResourceQuota)

  const handleDelete = useCallback(async () => {
    await deleteFn(resourceQuota)
    onClose(true)
    history.push(routes[routePath].resourceQuotas.list.path())
  }, [resourceQuota, routePath])

  return (
    <Modal
      panel="dialog"
      open
      onClose={onClose}
      title={`Remove Resource Quota "${resourceQuota?.name}" ?`}
      maxWidth={600}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={deletingResourceQuota}>
            Cancel
          </Button>
          <Button onClick={handleDelete} loading={deletingResourceQuota}>
            Delete
          </Button>
        </>
      }
    >
      <Text variant="body2">Your data will be lost since this action cannot be undone.</Text>
    </Modal>
  )
}
